import React, { useCallback, useContext } from 'react';

import { EmergencyContactContext } from '../../emergency-contacts.context';
import EmergencyContactForm from '../Form';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload } = useContext(EmergencyContactContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <EmergencyContactForm open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
